// extracted by mini-css-extract-plugin
export var closeButton = "_l6-2";
export var closeButtonIcon = "_l6-3";
export var lightboxContent = "_l6-1";
export var lightboxOverlay = "_l6-0";